//公共
export const COM_NAV_STATUS     = 'COM_NAV_STATUS'
export const COM_HEADER_STATUS  = 'COM_HEADER_STATUS'
export const COM_LOADING_STATUS = 'COM_LOADING_STATUS'

export const COM_SHOW_TOAST = 'COM_SHOW_TOAST'              //显示toast
export const COM_SHOW_SUCCESS = 'COM_SHOW_SUCCESS'          //显示成功toast
export const COM_SHOW_FAIL = 'COM_SHOW_FAIL'                //显示失败toast
export const COM_TOAST_MSG = 'COM_TOAST_MSG'                //显示toast文字
export const COM_SHOW_ALERT = 'COM_SHOW_ALERT'
export const COM_ALERT_MSG = 'COM_ALERT_MSG'

//user 用户
export const SET_USER_INFO      = 'SETUSERINFO'      //设置用户信息
export const SET_LOGIN_STATUS   = 'SET_LOGIN_STATUS' //设置登录状态
export const SET_USER_DATA      = 'SET_USER_DATA'    //获取用户数据信息
export const ADD_USER_FAVOURITE      = 'ADD_USER_FAVOURITE'    //添加用户收藏老师
export const DELETE_USER_FAVOURITE      = 'DELETE_USER_FAVOURITE'    //删除用户收藏老师


// WEBPACK FOOTER //
// ./src/vuex/types.js